export default [
  // INTRO
  {m:1, t: 1, pos: 1},
  {m:1, t: 2, pos: 4},
  {m:1, t: 3, pos: 2},
  {m:1, t: 4, pos: 1},
  {m:1, t: 5, pos: 5},
  {m:1, t: 6, pos: 2},
  {m:1, t: 7, pos: 4},
  {m:1, t: 8, pos: 2},

  {m:2, t: 1, pos: 1},
  {m:2, t: 2, pos: 4},
  {m:2, t: 3, pos: 2},
  {m:2, t: 4, pos: 1},
  {m:2, t: 5, pos: 5},
  {m:2, t: 6, pos: 2},
  {m:2, t: 7, pos: 4},
  {m:2, t: 8, pos: 2},

  {m:3, t: 1, pos: 2},
  {m:3, t: 2, pos: 4},
  {m:3, t: 3, pos: 2},
  {m:3, t: 4, pos: 1},
  {m:3, t: 5, pos: 5},
  {m:3, t: 6, pos: 2},
  {m:3, t: 7, pos: 4},
  {m:3, t: 8, pos: 2},

  {m:4, t: 1, pos: 2},
  {m:4, t: 2, pos: 4},
  {m:4, t: 3, pos: 2},
  {m:4, t: 4, pos: 1},
  {m:4, t: 5, pos: 5},
  {m:4, t: 6, pos: 2},
  {m:4, t: 7, pos: 4},
  {m:4, t: 8, pos: 2},

  {m:5, t: 1, pos: 3},
  {m:5, t: 2, pos: 4},
  {m:5, t: 3, pos: 2},
  {m:5, t: 4, pos: 1},
  {m:5, t: 5, pos: 5},
  {m:5, t: 6, pos: 2},
  {m:5, t: 7, pos: 4},
  {m:5, t: 8, pos: 2},

  {m:6, t: 1, pos: 3},
  {m:6, t: 2, pos: 4},
  {m:6, t: 3, pos: 2},
  {m:6, t: 4, pos: 1},
  {m:6, t: 5, pos: 5},
  {m:6, t: 6, pos: 2},
  {m:6, t: 7, pos: 4},
  {m:6, t: 8, pos: 2},

  {m:7, t: 1, pos: 1},
  {m:7, t: 2, pos: 4},
  {m:7, t: 3, pos: 2},
  {m:7, t: 4, pos: 1},
  {m:7, t: 5, pos: 5},
  {m:7, t: 6, pos: 2},
  {m:7, t: 7, pos: 4},
  {m:7, t: 8, pos: 2},

  {m:8, t: 1, pos: 1},
  {m:8, t: 2, pos: 4},
  {m:8, t: 3, pos: 2},
  {m:8, t: 4, pos: 1},
  {m:8, t: 5, pos: 5},
  {m:8, t: 6, pos: 2},
  {m:8, t: 7, pos: 4},
  {m:8, t: 8, pos: 2},

  // INTRO REPEAT

  {m:9, t: 1, pos: 1},
  {m:9, t: 2, pos: 4},
  {m:9, t: 3, pos: 2},
  {m:9, t: 4, pos: 1},
  {m:9, t: 5, pos: 5},
  {m:9, t: 6, pos: 2},
  {m:9, t: 7, pos: 4},
  {m:9, t: 8, pos: 2},

  {m:10, t: 1, pos: 1},
  {m:10, t: 2, pos: 4},
  {m:10, t: 3, pos: 2},
  {m:10, t: 4, pos: 1},
  {m:10, t: 5, pos: 5},
  {m:10, t: 6, pos: 2},
  {m:10, t: 7, pos: 4},
  {m:10, t: 8, pos: 2},

  {m:11, t: 1, pos: 2},
  {m:11, t: 2, pos: 4},
  {m:11, t: 3, pos: 2},
  {m:11, t: 4, pos: 1},
  {m:11, t: 5, pos: 5},
  {m:11, t: 6, pos: 2},
  {m:11, t: 7, pos: 4},
  {m:11, t: 8, pos: 2},

  {m:12, t: 1, pos: 2},
  {m:12, t: 2, pos: 4},
  {m:12, t: 3, pos: 2},
  {m:12, t: 4, pos: 1},
  {m:12, t: 5, pos: 5},
  {m:12, t: 6, pos: 2},
  {m:12, t: 7, pos: 4},
  {m:12, t: 8, pos: 2},

  {m:13, t: 1, pos: 3},
  {m:13, t: 2, pos: 4},
  {m:13, t: 3, pos: 2},
  {m:13, t: 4, pos: 1},
  {m:13, t: 5, pos: 5},
  {m:13, t: 6, pos: 2},
  {m:13, t: 7, pos: 4},
  {m:13, t: 8, pos: 2},

  {m:14, t: 1, pos: 3},
  {m:14, t: 2, pos: 4},
  {m:14, t: 3, pos: 2},
  {m:14, t: 4, pos: 1},
  {m:14, t: 5, pos: 5},
  {m:14, t: 6, pos: 2},
  {m:14, t: 7, pos: 4},
  {m:14, t: 8, pos: 2},

  // CHANGES HERE ** FIX THIS **
  {m:15, t: 1, pos: 1},
  {m:15, t: 2, pos: 4},
  {m:15, t: 3, pos: 2},
  {m:15, t: 4, pos: 1},
  {m:15, t: 5, pos: 5},
  {m:15, t: 6, pos: 2},
  {m:15, t: 7, pos: 4},
  {m:15, t: 8, pos: 2},

  {m:16, t: 1, pos: 1},
  {m:16, t: 2, pos: 4},
  {m:16, t: 3, pos: 2},
  {m:16, t: 4, pos: 1},
  {m:16, t: 5, pos: 5},
  {m:16, t: 6, pos: 2},
  {m:16, t: 7, pos: 4},
  {m:16, t: 8, pos: 2},

  // ONE MORE TIME
  {m:17, t: 1, pos: 1},
  {m:17, t: 2, pos: 4},
  {m:17, t: 3, pos: 2},
  {m:17, t: 4, pos: 1},
  {m:17, t: 5, pos: 5},
  {m:17, t: 6, pos: 2},
  {m:17, t: 7, pos: 4},
  {m:17, t: 8, pos: 2},

  {m:18, t: 1, pos: 1},
  {m:18, t: 2, pos: 4},
  {m:18, t: 3, pos: 2},
  {m:18, t: 4, pos: 1},
  {m:18, t: 5, pos: 5},
  {m:18, t: 6, pos: 2},
  {m:18, t: 7, pos: 4},
  {m:18, t: 8, pos: 2},

  {m:19, t: 1, pos: 2},
  {m:19, t: 2, pos: 4},
  {m:19, t: 3, pos: 2},
  {m:19, t: 4, pos: 1},
  {m:19, t: 5, pos: 5},
  {m:19, t: 6, pos: 2},
  {m:19, t: 7, pos: 4},
  {m:19, t: 8, pos: 2},

  {m:20, t: 1, pos: 2},
  {m:20, t: 2, pos: 4},
  {m:20, t: 3, pos: 2},
  {m:20, t: 4, pos: 1},
  {m:20, t: 5, pos: 5},
  {m:20, t: 6, pos: 2},
  {m:20, t: 7, pos: 4},
  {m:20, t: 8, pos: 2},

  {m:21, t: 1, pos: 3},
  {m:21, t: 2, pos: 4},
  {m:21, t: 3, pos: 2},
  {m:21, t: 4, pos: 1},
  {m:21, t: 5, pos: 5},
  {m:21, t: 6, pos: 2},
  {m:21, t: 7, pos: 4},
  {m:21, t: 8, pos: 2},

  {m:22, t: 1, pos: 3},
  {m:22, t: 2, pos: 4},
  {m:22, t: 3, pos: 2},
  {m:22, t: 4, pos: 1},
  {m:22, t: 5, pos: 5},
  {m:22, t: 6, pos: 2},
  {m:22, t: 7, pos: 4},
  {m:22, t: 8, pos: 2},

  {m:23, t: 1, pos: 4},
  {m:23, t: 2, pos: 2},
  {m:23, t: 3, pos: 3},
  {m:23, t: 4, pos: 2},
  {m:23, t: 5, pos: 4},
  {m:23, t: 6, pos: 2},
  {m:23, t: 7, pos: 4},
  {m:23, t: 8, pos: 2},

  {m:24, t: 1, pos: 5},
  {m:24, t: 2, pos: 2},
  {m:24, t: 3, pos: 4},
  {m:24, t: 4, pos: 2},
  {m:24, t: 5, pos: 4, hold: 2}, // hold 2 beats
  // {m:24, t: 6, pos: 4},
  {m:24, t: 7, pos: 3, hold: 2}, // hold 2 beats
  // {m:24, t: 8, pos: 2},

  // m:25 holding
  // m:26 nothing until t:8
];



//////////////////
// WEBPACK FOOTER
// ./lib/songs/song_intro.js
// module id = 9
// module chunks = 0